import React from 'react'
import { styled, useTheme } from 'src/ui/theme'
import { Header, Body } from 'src/ui/typography'
import { HBox } from 'src/ui/layout'
import { RewardRow } from '../../molecules'
import { developers, adminEmployees } from '../../utils'
import { breakpoints, useDimensions } from 'src/ui/dimensions'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1312px;
  margin: 64px auto 0;

  @media (max-width: ${breakpoints.desktop}px) {
    margin: 64px;
  }

  @media (max-width: ${breakpoints.mobile}px) {
    width: calc(100% - 32px);
    margin: 0 16px;
  }
`

const Title = styled(Header)`
  @media (max-width: ${breakpoints.mobile}px) {
    margin: 16px 0;
    padding-right: 28px;
  }
`

const Subtitle = styled(Body)<{ $color?: string }>`
  color: ${({ $color }) => $color};

  @media (max-width: ${breakpoints.mobile}px) {
    font-size: 14px;
  }
`

export const Reward = () => {
  const theme = useTheme()
  const { isMobile } = useDimensions()

  const titleFontSize = isMobile ? 'h4' : 'h2'

  return (
    <Wrapper>
      <Title size={titleFontSize}>
        Сколько мы платим за успешную рекомендацию?
      </Title>
      <HBox height={24} />
      <Subtitle $color={theme.colors.black.secondary}>
        Производство (разработчики, аналитики, дизайнеры, PM, QA)
      </Subtitle>
      <HBox height={isMobile ? 24 : 48} />
      <RewardRow items={developers} />
      <HBox height={isMobile ? 24 : 64} />
      <Subtitle $color={theme.colors.black.secondary}>
        Администрация (рекрутеры, HR, бухгалтерия, коммерция, PR)
      </Subtitle>
      <HBox height={isMobile ? 24 : 48} />
      <RewardRow items={adminEmployees} />
    </Wrapper>
  )
}
